export function UnreachableError(x: never): never {
  throw new Error("Didn't expect to get here")
}

export function UnwriteableError(x: never): never {
  throw new Error("Didn't expect to get here")
}